import styled, { css } from 'styled-components'

export const ImageWrapper = styled.div<{
  loaded?: boolean
  error?: boolean
  fitImageToWrapper?: boolean
  alignment?: 'left' | 'center'
}>`
  background: var(--background);
  max-width: 100%;
  ${({ fitImageToWrapper }) =>
    fitImageToWrapper &&
    css`
      --color-background: transparent;
      align-items: center;
      display: flex;
      height: 100%;
    `}
  ${({ alignment }) =>
    alignment === 'center' &&
    css`
      --color-background: transparent;
      margin: 0 auto;
    `}
  img {
    display: block;
    height: auto;
    margin: 0 auto;
    max-width: 100%;
    object-fit: cover;
    opacity: 0;
    transition: 0.2s opacity;
    width: auto;
    &.fit-image {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
    &.loaded {
      opacity: 1;
    }
  }
`
